export default {
  getXeroReport: (state) => state.xeroReport,
  getTrialBalances: (state) => {
    const { xeroReports } = state;
    return xeroReports;
  },
};
